import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container, Row, Col } from 'react-bootstrap';

import config from '../../../../../config.js';

import { getContentBlockItemValue } from '../../../CmsActions.js';

import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';

// Icon per reassurance item (plain PNG in assets/images/home). Mapped to the block meaning:
// shipping = livraison offerte, delivery = préparation/expédition, order = satisfaction client.
const ICONS = {
    shipping: { icon: 'delivery-man-icon', variant: 'success' },
    delivery: { icon: 'delivery-truck', variant: 'warning' },
    order: { icon: 'box-love-icon', variant: 'danger' },
};

function PanelShipping({ panel, mode = null, forceColumn = false }) {
    const shipping = getContentBlockItemValue(panel.blocks, 'shipping');
    const delivery = getContentBlockItemValue(panel.blocks, 'delivery');
    const order = getContentBlockItemValue(panel.blocks, 'order');

    // Compact mode (footer, product page): text only, centered — unchanged.
    if(mode === 'compact') {
        const renderCompact = content => (
            <Col xs={forceColumn ? 4 : 12} sm="4" md="4">
                <div className="pe-2 pe-md-0 text-center text-sm-center">
                    <HtmlComponent text={content} />
                </div>
            </Col>
        );
        return (
            <Row className="g-0 text-center align-items-center panel-shipping panel-shipping-mode-compact">
                {renderCompact(shipping)}
                {renderCompact(delivery)}
                {renderCompact(order)}
            </Row>
        );
    }

    // Default ("réassurance") mode: icon badge + title/sub, 3 across — matches the redesign.
    const renderPart = (content, { icon, variant }) => (
        <Col xs="12" md="4">
            <div className="reassurance-item d-flex align-items-center gap-3 py-2">
                <span className={classNames('reassurance-icon', `reassurance-icon-${variant}`, 'flex-shrink-0')}>
                    {/* Decorative: the adjacent text carries the meaning. alt="" + role="presentation"
                        removes it from the accessibility tree instead of leaving an unlabelled image. */}
                    <img
                        src={`${config.url}assets/images/home/${icon}.png`}
                        alt=""
                        role="presentation"
                        width="34"
                        height="34"
                        loading="lazy"
                    />
                </span>
                <div className="ps-lg-4 text-start panel-shipping-text">
                    <HtmlComponent text={content} />
                </div>
            </div>
        </Col>
    );

    return (
        <div className={classNames('panel-shipping', 'panel-shipping-mode-default', 'p-0')}>
            <Container>
                <Row className="align-items-center g-1 g-md-3 py-3">
                    {renderPart(shipping, ICONS.shipping)}
                    {renderPart(delivery, ICONS.delivery)}
                    {renderPart(order, ICONS.order)}
                </Row>
            </Container>
        </div>
    );
}

PanelShipping.propTypes = {
    panel: PropTypes.object.isRequired,
    mode: PropTypes.string,
    forceColumn: PropTypes.bool,
};

export default PanelShipping;
